/**
 * Created by work on 17/6/28.
 */
export const REFRESH_LIFE_BANK_TAB = 'REFRESH_LIFE_BANK_TAB';
export const SCROLL_TO_TOP = 'SCROLL_TO_TOP';

export const refreshLifeBankTab = (newTab) => ({
  type: REFRESH_LIFE_BANK_TAB,
  newTab
});
export const scrollToTop = (newTop) => ({
  type: SCROLL_TO_TOP,
  newTop
});


// WEBPACK FOOTER //
// ./src/actions/lifebank.js